(function(){
  var KEY='vcPopSeen', DAYS=30, DELAY=6000, LIST='TyeeBG', CO='Y24a6S';
  var EP='https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  var ROUTE={muscle:['/products/a2-protein-chocolate-milk','A2 PROTEIN'],
             weight:['/products/a2-protein-chocolate-milk','A2 PROTEIN'],
             energy:['/products/ignite','IGNITE'],
             recover:['/products/creatine-x-collagen-capsules','CREATINE x COLLAGEN'],
             age:['/products/creatine-x-collagen-capsules','CREATINE x COLLAGEN']};
  var LINE={muscle:'building muscle',weight:'losing weight',energy:'more energy',
            recover:'recovering faster',age:'aging strong'};
  function seen(){try{var v=localStorage.getItem(KEY);return v&&(Date.now()-(+v))<DAYS*864e5;}catch(e){return false;}}
  function mark(){try{localStorage.setItem(KEY,String(Date.now()));}catch(e){}}
  function send(p){
    var b=Object.keys(p).map(function(k){return encodeURIComponent(k)+'='+encodeURIComponent(p[k]);}).join('&');
    return fetch(EP,{method:'POST',headers:{'content-type':'application/x-www-form-urlencoded'},body:b}).catch(function(){});
  }
  document.addEventListener('DOMContentLoaded',function(){
    var el=document.getElementById('vcPop');
    if(!el||seen())return;
    var goal='', email='', shown=false;
    function step(n){for(var i=1;i<=4;i++){var s=el.querySelector('[data-vc-step="'+i+'"]');if(s)s.hidden=(i!==n);}}
    function show(){if(shown)return;shown=true;el.hidden=false;document.body.style.overflow='hidden';
      requestAnimationFrame(function(){el.classList.add('is-in');});}
    function hide(){el.classList.remove('is-in');mark();document.body.style.overflow='';
      setTimeout(function(){el.hidden=true;},250);}
    setTimeout(show,DELAY);
    document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<10)show();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!el.hidden)hide();});

    // Step 1: goal
    el.addEventListener('click',function(e){
      var g=e.target.closest('[data-goal]');
      if(g){
        goal=g.getAttribute('data-goal');
        var ln=el.querySelector('[data-vc-goalline]');
        if(ln&&LINE[goal])ln.innerHTML='Your 25% subscriber price and a short plan for '+LINE[goal]+'.';
        step(2);
        var i=el.querySelector('input[name="email"]'); if(i)setTimeout(function(){i.focus();},80);
        return;
      }
      if(e.target.closest('[data-vc-close]')){if(e.target.tagName!=='A')e.preventDefault();hide();}
    });

    // Step 2: email. Saved immediately so a drop-off at the phone step still keeps the lead.
    var f1=el.querySelector('[data-vc-email-form]');
    f1.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=el.querySelector('[data-vc-email-submit]'), err=el.querySelector('[data-vc-err1]');
      var v=(f1.email.value||'').trim(); err.hidden=true;
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){err.textContent='Please enter a valid email address.';err.hidden=false;return;}
      email=v; btn.disabled=true; btn.textContent='SAVING...';
      var p={g:LIST,a:CO,'$fields':'email',email:email};
      if(goal){p['$fields']='email,goal';p.goal=goal;}
      send(p).then(function(){
        mark(); step(3);
        var ph=el.querySelector('input[name="phone"]'); if(ph)setTimeout(function(){ph.focus();},80);
      });
    });

    // Step 3: phone
    var f2=el.querySelector('[data-vc-phone-form]');
    f2.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=el.querySelector('[data-vc-phone-submit]'), err=el.querySelector('[data-vc-err2]');
      var d=(f2.phone.value||'').replace(/\D/g,''); err.hidden=true;
      if(d.length===10){d='1'+d;}
      if(d.length!==11||d.charAt(0)!=='1'){err.textContent='Please enter a valid US mobile number.';err.hidden=false;return;}
      btn.disabled=true; btn.textContent='SAVING...';
      send({g:LIST,a:CO,'$fields':'email,phone_number,sms_consent',email:email,
            phone_number:'+'+d,sms_consent:'true'}).then(function(){
        var cta=el.querySelector('[data-vc-cta]'), r=ROUTE[goal];
        if(cta&&r){cta.setAttribute('href',r[0]);cta.textContent='SHOP '+r[1];}
        step(4);
      });
    });
  });
})();
